import React, { useEffect, useState } from 'react';
import '../../../App.css';
import '../Sculc.css';
import { useAuth } from '../../../contexts/AuthContext.js';
import { useNavigate } from 'react-router-dom';
import {getFirestoreData} from '../../../firebase/Firestore.js'
import './Sculc2026.css';
const Sculc2026 = () => {
    const navigate = useNavigate();
    const { currentUser } = useAuth();
    const [isSculcPresenter, setIsSculcPresenter] = useState(false);
    const [isSculcApplicant, setIsSculcApplicant] = useState(false);

    useEffect(() => {
        const getUserData = async () => {
          if (currentUser) {
            const isSculcPresenter = await getFirestoreData('Users', currentUser.uid, 'sculc_presenter', false);
            setIsSculcPresenter(isSculcPresenter);
            const isSculcApplicant = await getFirestoreData('Users', currentUser.uid, 'sculc_applicant', false);
            setIsSculcApplicant(isSculcApplicant);
          }
        };
    
        getUserData();
      }, [currentUser]);

    const navToViewSubmission = () => {
        navigate('/sculc/view-submission'); // Navigate to View Submission if the user is an applicant
    };
    const navToSubmitAbstract = () => {
        navigate('/sculc/submit-abstract'); // Navigate to Submit Abstract if the user is not an applicant
    };
    const navToCongratulations = () => {
        navigate('/sculc/congratulations-page'); // Navigate to View Submission if the user is an applicant
    };


    return (
        <div className="sculc-page">
            
            <div className="sculc2025-header-container">
                <img
                    src="/images/new-sculc-header.png"
                    alt="Header"
                    className="sculc2025-header-image"
                />  
                <h1 className="sculc2025-title">SCULC 2026</h1>
            </div>
            <div className="sculc2025-banner">
                    <p style={{ fontSize: "1.5em" }}>SCULC 2026 has concluded!</p>
                    <br />
                    <a href="/sculc-2027" className="sculc2027-link">Stay tuned for SCULC 2027!</a>
                </div>
                <div className="sculc-container">
                    <div className="side-menu">
                        <ul>
                            {/* <li><a href="#event-details">Event Details</a></li> */}
                            <li><a href="#about-sculc">About SCULC</a></li>
                            <li><a href="#keynote-speaker">Keynote Speaker</a></li>
                            <li><a href="#conference-info">Program</a></li>
                            {/* <li><a href="#presentations">Presentations</a></li> */}
                            <li><a href="#contact-info">Contact Info</a></li>
                        </ul>
                    </div>

                    <div className="main-content">
                        <div id="event-details" className="event-details">
                            <div className="event-details-container">
                                <img
                                    src="/images/sculc-logo.png"
                                    alt="SCULC Logo"
                                    className="conference-logo"
                                />
                                <p className="event-date-time">
                                    <strong>Saturday, 16 May 2026</strong><br />
                                    09:00 AM - 05:30 PM<br />
                                    UCLA's Campbell Hall Learning Pavilion
                                </p>
                            </div>
                            {/* <p className="sculc25-zoom sculc-box">
                            <span className="zoom-icon-wrapper">
                                    <img 
                                    src="/images/zoom-icon.png" 
                                    alt="Zoom Icon" 
                                    className="zoom-icon"
                                    />
                                </span>
                                Join virtually here! :&nbsp;
                                <a 
                                    href="https://ucla.zoom.us/j/94995926899"
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    className="sculc25-zoom-link"
                                >
                                    SCULC 2025 Zoom Link
                                </a>
                            </p> */}
                            {/* <p className="general-attendee sculc-box">
                                Please Check In Here! : <a 
                                    href="https://forms.gle/L7tZUkkVb3YkfYUt9"
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    className="general-attendee-link"
                                >
                                    SCULC 2025 Check In 
                                </a>
                            </p> */}

                            {/* <h2 className="subtitle">EVENT DETAILS</h2> */}



                            {/* <p className="event-description">
                            Check-in will begin at 8:30 AM in the Campbell Hall Learning Pavilion lobby. 
                            Attendees are encouraged to dress in business casual attire.
                            For parking details and directions to Campbell Hall, see <a 
                                href="https://www.maps.ucla.edu/?id=2043#!ct/75713,67721,77384?m/696623?s/" 
                                className="embedded-link" 
                                target="_blank" 
                                rel="noopener noreferrer">this map
                            </a>. 
                            Parking can be paid at the pay station or through the <a 
                                href="https://apps.apple.com/us/app/parkmobile-park-pay-go/id365399299" 
                                className="embedded-link" 
                                target="_blank" 
                                rel="noopener noreferrer"> ParkMobile
                            </a> app.
                            Lunch will be served for all registered attendees, 
                            Attendance is free for all participants, presenters, and guests.
                            </p> */}

                            <div id="about-sculc" className="about-sculc">
                                {/* <h2 className="subtitle">ABOUT SCULC</h2> */}
                                <p className="event-description">
                                Southern California Undergraduate Linguistics Conference (SCULC) was held on May 16, 2026 by the University of California, Los Angeles Linguistics Department and the undergraduate-run linguistics society, Bruin Linguists Society. 
                                </p>
                                <p className="event-description">
                                    Founded in 2010 by Bruin Linguists, SCULC was established to create a collaborative and educational environment for the undergraduate linguistics community. Throughout the years, it has been entirely student-run and free for all participants, presenters, and guests, supported by contributions from the linguistics community, the UCLA Linguistics Department, and individuals working to help enhance and expand the experience of undergraduates in linguistics.
                                </p>

                                {/* Mailing List */}
                                

                                    {/* Sponsors */}
                                    <p className="sponsors">Sponsored by the UCLA Department of Linguistics and the Bruin Linguists Society</p>
                            </div>
                            {/*
                            <div id="call-for-abstracts" className="call-for-abstracts">
                                <h2 className="subtitle">CALL FOR ABSTRACTS</h2>
                                <p className="event-description">
                                <strong>Deadline for Abstracts:</strong> March 15th, 2025<br />
                                <strong>Notifications:</strong> March 29th, 2025<br />
                                </p>
                                <p className="event-description">
                                Abstract submissions will be considered for poster and oral presentations. 
                                When submitting, you may indicate your preference for consideration for one 
                                or both types of presentations in the submission comment box. All abstracts 
                                will be reviewed anonymously. You may submit abstracts for projects that are 
                                either in progress or have been completed. Please ensure your abstracts are 
                                less than 500 words, figures and references not included in the word limit. 
                                </p>
                            </div>
                            

                                
                            {isSculcApplicant ? (
                                <button onClick={navToViewSubmission} className="blue-button"> View Submission Status</button>
                            ) : (
                                <button onClick={navToSubmitAbstract} className="blue-button"> Submit An Abstract</button>
                            )}
                            */}




                                {/* Keynote Speaker */}
                                <div id="keynote-speaker" className="keynote-speaker">
                                    <h2 className="keynote-title">KEYNOTE SPEAKER</h2>
                                    <div className="keynote-content">
                                        <img
                                            src="/images/Reed_hat_cropped.jpeg"
                                            alt="Reed Blaylock"
                                            className="keynote-image"
                                            width="160" height="220"
                                        />
                                        <div className="keynote-details">
                                            <h3 className="keynote-name">Reed Blaylock, Ph.D.</h3>
                                            <p className="keynote-affiliation"> Chapman University </p>
                                            <p className="keynote-description">
                                                <strong>Vocal Flexibility in Beatrhyming</strong>
                                                <br />
Sometimes the human vocal tract has to manage simultaneous and competing demands. Understanding how speech changes in these multi-task situations can help us learn more about the flexibility of linguistic units and the grammars that govern them. Beatrhyming is a type of musical speech in which a person beatboxes and sings simultaneously, and is particularly notable because the musical and linguistic units intersect via segment-sized articulations (rather than, say, pitch). In beatrhyming, faithfulness to the underlying lyrics is achieved by replacing speech sounds with beatboxing sounds that match in place of articulation. But this place-matching rule can be overruled by snares performed regularly in service of the musical beat. In this presentation I analyze the sound patterns of beatrhyming and provide a grammar to account for how the vocal tract resolves the competing demands of beatboxing and speech.
                                            </p>
                                            {/* <p className="keynote-abstract">
                                                <a 
                                                    href="https://docs.google.com/document/d/1K5Q8t9fnjdiwZXMxeF_WEr2mW9lxzkMG/edit?usp=sharing&ouid=104781865078171920700&rtpof=true&sd=true" 
                                                    target="_blank" 
                                                    rel="noopener noreferrer"
                                                    className="keynote-abstract-link"
                                                >
                                                    Read the Keynote Abstract
                                                </a>
                                            </p> */}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div id="conference-info" className="conference-info">
                                <h2 className="subtitle">PROGRAM</h2>
                                <p className="normal-text">
                                    Please see below for the official 2026 conference program. You can also <a
                                        href="/SCULC%202026%20Conference%20Program.pdf"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="embedded-link"
                                    >
                                        download the PDF
                                    </a>.
                                </p>
                                <iframe
                                src="/SCULC%202026%20Conference%20Program.pdf"
                                title="SCULC 2026 Conference Program"
                                width="100%"
                                height="600px"
                                style={{ border: '1px solid #ccc', borderRadius: '8px' }}
                                ></iframe>

                            </div>


                            {/* Contact Information */}
                            <div id="contact-info" className="contact-info">
                                <h2 className="subtitle">CONTACT INFO</h2>
                                <p  style={{ marginBottom: '1.5rem' }}>

                                </p>
                                <p className="normal-text">
                                    Applications for SCULC 2027 have not yet opened, but if you are interested in presenting or attending don't hesitate to contact the organizers at <a href="mailto:bruinlinguists@gmail.com" className="email-link">bruinlinguists@gmail.com</a>. Be sure to specify in the subject line that your correspondence is related to SCULC 2027.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>       
    );
};

export default Sculc2026;

                            // {isSculcPresenter ? (
                            //     <button onClick={navToCongratulations} className="blue-button">View Submission Status</button>
                            // ) : isSculcApplicant ? (
                            //     <button onClick={navToViewSubmission} className="blue-button">View Submission Status</button>
                            // ) : (
                            //     <> {/* Placeholder to maintain structure */} </>
                            // )}